import styled from 'styled-components'

export const SearchWrapper = styled.div`
  .results {
    max-height: 400px;
    overflow-y: auto;

    .result {
      display: flex !important;
      align-items: center;
    }
  }
`
